/**
 * PDP Product Details Accordions - mobile "See more" toggle
 * Idempotent init, scoped to [data-pdp-details] roots. Labels hardcoded.
 */
(function () {
  const ATTR_BOUND = 'data-pdp-details-bound';
  const SELECTOR_ROOT = '[data-pdp-details]';
  const SELECTOR_SEE_MORE = '[data-see-more]';
  const SELECTOR_CONTENT = '.pdp-details__mobile-desc-content';
  const CLASS_CLAMPED = 'is-clamped';
  const LABEL_MORE = 'Read more';
  const LABEL_LESS = 'See less';

  function initRoot(root) {
    if (root.getAttribute(ATTR_BOUND) === 'true') return;
    root.setAttribute(ATTR_BOUND, 'true');

    const btn = root.querySelector(SELECTOR_SEE_MORE);
    const content = root.querySelector(SELECTOR_CONTENT);
    if (!btn || !content) return;

    btn.addEventListener('click', function () {
      const wasClamped = content.classList.contains(CLASS_CLAMPED);
      content.classList.toggle(CLASS_CLAMPED);
      const isNowClamped = content.classList.contains(CLASS_CLAMPED);
      btn.setAttribute('aria-expanded', String(!isNowClamped));
      btn.textContent = isNowClamped ? LABEL_MORE : LABEL_LESS;
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll(SELECTOR_ROOT).forEach(initRoot);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll(SELECTOR_ROOT).forEach(initRoot);
    }
  });
})();
